import Base from "./base"
class Curd extends Base {
    //列表
    list(page = 1, pageSize = 10, condition = {}) {
        let cond = {
            page: page,
            pageSize: pageSize
        }

        cond = Object.assign(cond, condition)
        return this.runGet(`s`, cond);
    }

    //单条记录
    single(id) {
        return this.runGet(`/${id}`)
    }

    //更新数据
    update(id, data) {
        return this.runPut(`/${id}`, data)
    }

    //删除数据
    del(id) {
        return this.runDelete(`/${id}`)
    }

    //创建数据
    create(data) {
        return this.runPost(``, data)
    }
}

export default Curd